/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFuel32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.165 4.335a1.75 1.75 0 011.863.553l1.596 1.92a1.75 1.75 0 01-.782 2.775L5.808 12.32a1.75 1.75 0 01-2.314-1.656V8c0-.767.5-1.444 1.232-1.671l6.439-1.995zm.71 1.512a.25.25 0 00-.267-.079L5.17 7.762a.25.25 0 00-.176.24v2.66a.25.25 0 00.33.237l8.035-2.736a.25.25 0 00.111-.396l-1.595-1.92zM19.573 26.658a1.75 1.75 0 000-2.475l-2.648-2.649a.25.25 0 010-.353l2.648-2.648a1.75 1.75 0 000-2.475l-1.023-1.024a1.75 1.75 0 00-2.475 0l-2.648 2.649a.25.25 0 01-.354 0l-2.648-2.649a1.75 1.75 0 00-2.475 0l-1.023 1.024a1.75 1.75 0 000 2.475l2.648 2.648a.25.25 0 010 .353l-2.648 2.649a1.75 1.75 0 000 2.475L7.95 27.68a1.75 1.75 0 002.475 0l2.648-2.648a.25.25 0 01.354 0l2.648 2.648a1.75 1.75 0 002.475 0l1.023-1.023zm-1.06-1.415a.25.25 0 010 .354l-1.024 1.023a.25.25 0 01-.353 0l-2.649-2.648a1.75 1.75 0 00-2.475 0L9.364 26.62a.25.25 0 01-.353 0l-1.024-1.023a.25.25 0 010-.354l2.649-2.648a1.75 1.75 0 000-2.475l-2.649-2.648a.25.25 0 010-.354l1.024-1.023a.25.25 0 01.353 0l2.648 2.648a1.75 1.75 0 002.475 0l2.649-2.648a.25.25 0 01.353 0l1.023 1.023a.25.25 0 010 .354l-2.648 2.648a1.75 1.75 0 000 2.475l2.649 2.648z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M18.794 5.541l-4.14-4.305a2.75 2.75 0 00-2.82-.713L1.912 3.698A2.75 2.75 0 000 6.318v22.54a2.75 2.75 0 002.75 2.75h21a2.75 2.75 0 002.75-2.75v-13.39a4.75 4.75 0 00-1.326-3.291l-.72-.749.9-.865a1.75 1.75 0 00.12-2.394 11.25 11.25 0 015.719-3.035l.807-.16V.857h-1.004A12.75 12.75 0 0022 4.573a1.75 1.75 0 00-2.308.104l-.898.864zm-5.22-3.265a1.25 1.25 0 00-1.283-.324L2.37 5.127a1.25 1.25 0 00-.869 1.19v22.54c0 .691.56 1.25 1.25 1.25h21c.69 0 1.25-.559 1.25-1.25V15.47a3.25 3.25 0 00-.907-2.253l-.72-.748-.001.001-5.662-5.885.003-.003-4.14-4.305zm9.84 8.07l-3.58-3.724.898-.864a.25.25 0 01.353.007l3.236 3.363a.25.25 0 01-.007.354l-.9.865zm-.34-4.726l1.414 1.415A12.75 12.75 0 0130.5 3.75v-1.38a11.25 11.25 0 00-7.427 3.251z'
      />
    </svg>
  );
}

export default SvgFuel32;
